module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-lock2-7981607e.svg";